import {
  faArrowRotateLeft,
  faTriangleExclamation
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { T } from "@repo/transifex";
import { Button } from "~/components";

type GroupFilterErrorProps = {
  onRetry: () => void;
  disabled?: boolean;
};

/**
 * Compact sidebar error shown when the school selectors (year/class) fail to
 * load — its own island, independent of the student list. Retry refetches only
 * the school.
 */
export const GroupFilterError = ({
  onRetry,
  disabled
}: GroupFilterErrorProps) => (
  <div className="flex flex-col gap-3 rounded-xl bg-interface-negative-1 p-4">
    <div className="flex items-center gap-2.5">
      <span className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-interface-neutral-0 text-interface-negative-2">
        <FontAwesomeIcon icon={faTriangleExclamation} />
      </span>
      <p className="text-base font-bold text-interface-neutral-6">
        <T _str="Couldn't load classes" />
      </p>
    </div>
    <Button
      variant="neutral"
      size="medium"
      icon={faArrowRotateLeft}
      disabled={disabled}
      onClick={onRetry}
      className="w-full justify-center"
    >
      <T _str="Retry" />
    </Button>
  </div>
);
